import { Preferences } from "../enum/Preferences";
import { PreferenceValue } from "./Preference";

export const defaultUserPreferences: Array<PreferenceValue> = [
    {
        preferenceName: Preferences.DEBUG,
        value: 'false',
    },
    {
        preferenceName: Preferences.STATISTICIAN,
        value: 'false',
    },/*
    {
        preferenceName: Preferences.THEME,
        value: 'light',
    },*/
    {
        preferenceName: Preferences.USERCONTROLPANEL,
        value: 'false',
    },
    {
        preferenceName: Preferences.LANGUAGES,
        value: 'it',
    }
];

export const defaultCentrePreferences: Array<PreferenceValue> = [
    {
        preferenceName: Preferences.TYPEIMPORT,
        value: 'withChoice',
    },
    {
        preferenceName: Preferences.ASKCONSENT,
        value: 'true',
    },
    {
        preferenceName: Preferences.GCPSTRATEGY,
        value: 'never',
    },
];

